// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__F7ZCO","modalForm":"UpgradeEpcsModal_modalForm__1BRBA","modalFooter":"UpgradeEpcsModal_modalFooter__EZ4DN"};